import { createSlice } from '@reduxjs/toolkit';

/**
 * Backend returns V1 format (AlertsPriority_id, AlertPriority_*, etc.) - no transform needed.
 */
const initialState = {
  id: '',
  key: '',
  name: '',
  description: '',
  rows: [],
  readOnly: false,
  selectedRowId: 0
};

const alertsPrioritySlice = createSlice({
  name: 'alertsPriority',
  initialState,
  reducers: {
    resetAlertsPriorityState: (state) => {
      Object.assign(state, initialState);
    },
    setAlertsPriorityCode(state, action) {
        const { id, key, name, description, readOnly } = action.payload;
        state.id = id;
        state.key = key;
        state.name = name;
        state.description = description;
        state.readOnly = readOnly;
    },
    setAlertsPriorityRows(state, action) {
      const rawRows = Array.isArray(action.payload) ? action.payload : [];
      state.rows = rawRows;
    },
    setSelectedRowId(state, action) {
        state.selectedRowId = action.payload;
    },
    updateRow(state, action) {
        const { id, updatedRow } = action.payload;
        const existingRowIndex = state.rows.findIndex(d => d.AlertsPriority_id === id);
        if (existingRowIndex !== -1) {
            const updatedRows = state.rows.map((row, index) =>
                index === existingRowIndex ? updatedRow : row
            );
            return { ...state, rows: updatedRows };
        }
    },
  },
});

export const {
    resetAlertsPriorityState,
    setAlertsPriorityCode,
    setAlertsPriorityRows,
    updateRow,
    setSelectedRowId,
} = alertsPrioritySlice.actions;

export default alertsPrioritySlice.reducer;
